import { z } from 'zod';
import { PaginationQuerySchema } from '../common/index.js';
export const ApiKeyEnvironmentSchema = z.enum([
    'development',
    'staging',
    'production',
]);
export const API_KEY_ENVIRONMENT = ApiKeyEnvironmentSchema.enum;
export const API_KEY_ENVIRONMENT_OPTIONS = ApiKeyEnvironmentSchema.options;
export const ApiKeyPermissionSchema = z.enum([
    'ingest',
    'read',
    'write',
    'admin',
]);
export const API_KEY_PERMISSION = ApiKeyPermissionSchema.enum;
export const API_KEY_PERMISSION_OPTIONS = ApiKeyPermissionSchema.options;
export const ApiKeyStatusSchema = z.enum(['active', 'expired', 'revoked']);
export const API_KEY_STATUS = ApiKeyStatusSchema.enum;
export const API_KEY_STATUS_OPTIONS = ApiKeyStatusSchema.options;
export const CreateApiKeySchema = z.object({
    name: z.string().min(1, 'Name is required').max(100),
    description: z.string().max(500).optional(),
    permissions: z.array(ApiKeyPermissionSchema).optional().default(['admin']),
    rate_limit: z.number().int().min(100).max(10000).optional(),
    expires_at: z.string().datetime().optional(),
    environment: ApiKeyEnvironmentSchema.optional(),
    environment_id: z.string().min(1).optional(),
});
export const UpdateApiKeySchema = z.object({
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(500).optional(),
    permissions: z.array(ApiKeyPermissionSchema).optional(),
    rate_limit: z.number().int().min(100).max(10000).optional(),
    expires_at: z.string().datetime().nullable().optional(),
    environment_id: z.string().min(1).nullable().optional(),
    metadata: z
        .record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null()]))
        .optional(),
});
export const RevokeApiKeySchema = z.object({
    reason: z.string().max(200).optional(),
});
export const ListApiKeysQuerySchema = PaginationQuerySchema.extend({
    environment: ApiKeyEnvironmentSchema.optional(),
    environment_id: z.string().min(1).optional(),
    status: ApiKeyStatusSchema.optional(),
    search: z.string().optional(),
    sort: z
        .enum(['name', 'created_at', 'last_used_at', 'expires_at'])
        .default('created_at')
        .optional(),
    order: z.enum(['asc', 'desc']).default('desc').optional(),
});
export const ApiKeyResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    key: z.string().optional(),
    key_prefix: z.string(),
    permissions: z.array(ApiKeyPermissionSchema),
    rate_limit: z.number(),
    environment: ApiKeyEnvironmentSchema,
    environment_id: z.string().nullable().optional(),
    usage_count: z.number(),
    last_used_at: z.string().nullable(),
    last_ip: z.string().nullable(),
    expires_at: z.string().nullable(),
    is_active: z.boolean(),
    revoked_at: z.string().nullable(),
    revoked_reason: z.string().nullable(),
    metadata: z
        .record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null()]))
        .nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});
export const ApiKeyListItemSchema = ApiKeyResponseSchema.omit({ key: true });
export const PaginatedApiKeysResponseSchema = z.object({
    data: z.array(ApiKeyListItemSchema),
    meta: z.object({
        request_id: z.string(),
        timestamp: z.string(),
        pagination: z.object({
            page: z.number(),
            limit: z.number(),
            total: z.number(),
            total_pages: z.number(),
        }),
    }),
    links: z.object({
        self: z.string(),
        first: z.string(),
        last: z.string(),
        prev: z.string().nullable(),
        next: z.string().nullable(),
    }),
});
export const RotateApiKeyResponseSchema = z.object({
    id: z.string(),
    new_key: z.string(),
    key_prefix: z.string(),
    rotated_at: z.string(),
});
export const RevokeApiKeyResponseSchema = z.object({
    success: z.boolean(),
    revoked_at: z.string(),
    reason: z.string().nullable(),
});
export const ApiKeyValidationSchema = z.object({
    id: z.string(),
    tenant_id: z.string(),
    permissions: z.array(ApiKeyPermissionSchema),
    rate_limit: z.number(),
    tenant_status: z.string(),
    environment_id: z.string().optional(),
});
export const ApiKeyParamsSchema = z.object({ id: z.string() });
//# sourceMappingURL=index.js.map